// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

.progress-ring_progress-ring_vqQwf {
  margin: 0.5rem;
}

.progress-ring_progress-ring-svg_Lhzob {
  fill: transparent;
}

.progress-ring_progress-ring_vqQwf .progress-ring_progress-ring-ring_EgOSZ {
  stroke: var(--looks-light-transparent);
}

.progress-ring_progress-ring_vqQwf .progress-ring_progress-ring-value_kbwg7 {
  stroke: var(--looks-secondary);
  stroke-linecap: round;
}
`, "",{"version":3,"sources":["webpack://./src/components/progress-ring/progress-ring.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;AACvB","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n.progress-ring {\n  margin: 0.5rem;\n}\n\n.progress-ring-svg {\n  fill: transparent;\n}\n\n.progress-ring .progress-ring-ring {\n  stroke: var(--looks-light-transparent);\n}\n\n.progress-ring .progress-ring-value {\n  stroke: var(--looks-secondary);\n  stroke-linecap: round;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"progress-ring": `progress-ring_progress-ring_vqQwf`,
	"progressRing": `progress-ring_progress-ring_vqQwf`,
	"progress-ring-svg": `progress-ring_progress-ring-svg_Lhzob`,
	"progressRingSvg": `progress-ring_progress-ring-svg_Lhzob`,
	"progress-ring-ring": `progress-ring_progress-ring-ring_EgOSZ`,
	"progressRingRing": `progress-ring_progress-ring-ring_EgOSZ`,
	"progress-ring-value": `progress-ring_progress-ring-value_kbwg7`,
	"progressRingValue": `progress-ring_progress-ring-value_kbwg7`
};
export default ___CSS_LOADER_EXPORT___;
